export default {"src":"/_next/static/media/left.d26b69f4.svg","height":185,"width":143};